module.exports = __webpack_public_path__ + "img/australia-logo-icon.bd3d2abd.png";